// extracted by mini-css-extract-plugin
module.exports = {"multi-lingual-card":"multi-lingual-card___1Q8B3","multiLingualCard":"multi-lingual-card___1Q8B3"};